import { render } from "./UserComplaints.vue?vue&type=template&id=6461bc58&scoped=true"
import script from "./UserComplaints.vue?vue&type=script&lang=js"
export * from "./UserComplaints.vue?vue&type=script&lang=js"

import "./UserComplaints.vue?vue&type=style&index=0&id=6461bc58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6461bc58"]])

export default __exports__